import React from "react";
import PublicationLinks from "../../../../../components/Publications/components/PublicationLinks";
import { getVarsoUrl } from "../../../../../common/helpers/helpers";
import helpers from "../../../../../common/utils/utils";

const getValuesWithDrugUrls = (item, k, separator) => {
  const res = item[k].replace("[", "").replace("]", "").split(separator);
  const values = [];
  for (let i = 0; i < res.length; i++) {
    if (res[i].trim().includes(" ") || res[i].trim().includes("therapy")) {
      values.push(
        <span key={i}>
          {res[i]}
          {i !== res.length - 1 ? `${separator} ` : ""}
        </span>
      );
    } else {
      values.push(
        <span key={i}>
          <a
            key={i}
            target="_blank"
            href={getVarsoUrl(`http://www.dgidb.org/drugs/${res[i]}`)}
          >
            {res[i]}
          </a>
          {i !== res.length - 1 ? `${separator} ` : ""}
        </span>
      );
    }
  }
  return values;
};

const formatKey = (key) => {
  const res = key.split("_");
  const objKey = `${helpers.capitalizeFirstLetter(
    res[0]
  )} ${helpers.capitalizeFirstLetter(res[1])}`;
  return objKey;
};

const getOtherInformationRow = (j, item, k) => {
  let value = item[k];
  if (k === "normalized_cancer" || k === "drug") return null; // we do not show internal used values in frontend
  if (k === "combination_therapy") {
    if (item[k].includes(";")) {
      value = getValuesWithDrugUrls(item, k, ";");
    } else if (item[k].includes(",")) {
      value = getValuesWithDrugUrls(item, k, ",");
    } else if (item[k].includes("+")) {
      value = getValuesWithDrugUrls(item, k, "+");
    }
  }
  if (k === "pub_med_references") {
    return (
      <tr key={`${k}_${j}`}>
        <td width="20%">{formatKey(k)}</td>
        <td>
          <PublicationLinks ids={item[k]} />
        </td>
      </tr>
    );
  }
  const result = Array.isArray(value)
    ? value.map(helpers.capitalizeFirstLetter).join(",")
    : value;

  return (
    <tr key={`${k}_${j}`}>
      <td width="20%">{formatKey(k)}</td>
      <td>{result}</td>
    </tr>
  );
};

const displayYesNo = (item, entry) => {
  if (item[entry]) {
    return <span style={{ color: "rgb(0,204,0)" }}>Yes</span>;
  }
  return <span style={{ color: "rgb(228, 69, 61)" }}>No</span>;
};

export { displayYesNo, getOtherInformationRow };
